import { render, staticRenderFns } from "./LayoutMatch.vue?vue&type=template&id=4c157f2a&scoped=true&"
import script from "./LayoutMatch.vue?vue&type=script&lang=js&"
export * from "./LayoutMatch.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMatch.vue?vue&type=style&index=0&id=4c157f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c157f2a",
  null
  
)

export default component.exports